import {
  FormSlug,
  ImplementationGuideForm,
} from "@/components/ImplementationGuide/types";

const contentPromotionForm: ImplementationGuideForm = {
  title: "Content Promotion",
  subtitle:
    "Configure your teacher’s Newsela experience to ensure that the content they see matches your curricular and instructional priorities.",
  slug: FormSlug.ContentPromotion,
  form_image: "/images/implementation-guide/Content_Promotion.svg",
  form_index: 6,
  questions: [],
  resources: [
    {
      resource_name: "Content Promotion Overview",
      resource_link: "https://support.newsela.com/article/content-promotion/",
      todo_item: "Completed Content Promotion",
      alternative_link: "https://newsela.com/admin/content-promotion/",
      alternative_link_text: "Try Content Promotion",
    },
  ],
};

export default contentPromotionForm;
